import "./App.css";
import Home from "./Pages/Home";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import { Toaster } from "react-hot-toast";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ENVIRONMENT } from "./Utils/constants";
import Help from "./Pages/Help/Help";

function App() {
  return (
    <BrowserRouter basename="/">
      <Toaster />
      <Header />
      <Routes>
        <Route
          path="/connect-wallet/:connectionId"
          errorElement={
            <center>
              <h1
                style={{
                  color: "white",
                  fontSize: "16px",
                  display: "flex",
                  height: "100vh",
                  margin: "auto",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Something Went Wrong !
                <a href={ENVIRONMENT.TELEGRAM_BOT}> Go home</a>
              </h1>
            </center>
          }
          element={<Home />}
        />
        <Route
          path="/error"
          element={
            <center>
              <h4
                style={{
                  color: "white",
                  fontSize: "16px",
                  display: "flex",
                  height: "100vh",
                  margin: "auto",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  gap: "1rem"
                }}
              >
                Your session has expired.<br />
                Please restart your telegram game.
                <a href={ENVIRONMENT.TELEGRAM_BOT}> Go home</a>
              </h4>
            </center>
          }
        />
        <Route path="/help" element={<Help />} />
        <Route
          path="*"
          element={
            <center>
              <h1>Page Not Found!</h1>
            </center>
          }
        />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
